export const StorageConstants = {
  IDENTITY: 'identity',
  PLAYGROUND_STORE: 'playground_store',
  HAS_CUSTOM_SOCIAL_IMAGE: 'has_custom_social_image',
};
